import React, {useEffect, useState} from 'react';
import DocxViewer from '@components/common/DocxViewer/DocxViewer';
function VaccinationPackage1() {
    return (
        <DocxViewer fileUrl="https://betaweb.tnh.com.vn/bw_documents/goi-tam-soat-nguy-co-dot-quy-tam-soat-tieu-duong.docx" />
    );
}

export default VaccinationPackage1;
